import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "fontSize", "children", "title"];
import React, { forwardRef } from 'react';
import { SvgIcon } from '@mui/material';
var EzIconMui = forwardRef(function (_ref, ref) {
  var color = _ref.color,
    fontSize = _ref.fontSize,
    children = _ref.children,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  var isCommonColor = color === null || color === void 0 ? void 0 : color.startsWith('common.');
  return React.createElement(SvgIcon, _extends({
    color: isCommonColor ? undefined : color,
    ref: ref,
    sx: {
      color: isCommonColor ? color : undefined,
      fill: 'currentColor',
      fontSize: fontSize
    },
    titleAccess: title
  }, props), children);
});
EzIconMui.displayName = 'EzIconMui';
export default EzIconMui;